import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { compact } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VehicleEditorialEntities } from 'client/data/models/vehicle-editorial';
import { buildMakeModelInventoryCountPath, InventoryAggregateModel } from 'client/data/models/inventory-aggregate';
import { buildMakeModelDefaultYear, VehicleDefaultModel } from 'client/data/models/vehicle-v2-default';
import { generateNewFlatUrl } from 'site-modules/shared/utils/srp-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { getPlural } from 'client/utils/plural';

function ArticleSrpLinkUI({
  className = null,
  contentVehicle: { make, model } = null,
  defaultYear = null,
  isMobile = false,
  inventoryCount = null,
}) {
  if (!(model?.pubStates?.NEW || model?.pubStates?.NEW_USED)) {
    return null;
  }

  return (
    <div className={classnames('article-srp-link', className)} data-tracking-parent="article_srp_link">
      {!!inventoryCount && (
        <div className="heading-5 mb-0_75">
          See {inventoryCount} {compact([defaultYear, make?.name, model?.name]).join(' ')}{' '}
          {getPlural('vehicle', inventoryCount)} for sale near you
        </div>
      )}
      <Button
        color="primary-b"
        size="lg"
        className={classnames('py-0_5 px-1 text-transform-none text-decoration-none text-white px-md-2 fw-normal', {
          'w-100': isMobile,
        })}
        style={{ whiteSpace: 'normal' }}
        tag={Link}
        to={generateNewFlatUrl({
          make: make?.slug,
          model: model?.slug,
        })}
        data-tracking-parent="article_srp_link"
        data-tracking-id="srp_link"
      >
        See All for Sale
      </Button>
    </div>
  );
}

ArticleSrpLinkUI.propTypes = {
  contentVehicle: VehicleEditorialEntities.vehicle,
  defaultYear: PropTypes.number,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  inventoryCount: PropTypes.number,
};

export const ArticleSrpLink = connectToModel(ArticleSrpLinkUI, {
  inventoryCount: bindToPath(
    ({ contentVehicle: { make, model } }) =>
      buildMakeModelInventoryCountPath({ make: make?.slug, model: model?.slug, radius: 100 }),
    InventoryAggregateModel
  ),
  defaultYear: bindToPath(
    ({ contentVehicle: { make, model } }) => buildMakeModelDefaultYear({ make: make?.slug, model: model?.slug }),
    VehicleDefaultModel
  ),
});
